<template>
    <div>
        <div class="form-group m-2">
            <label for=""></label>
            <input type="file" class="form-control-file" ref="file" placeholder="" aria-describedby="fileHelpId" v-on:change="handleFile()">
            <small id="fileHelpId" class="form-text text-muted">Story Image</small>
        </div>
        <quill-editor v-model="content" :options="editorOption">
            <div id="toolbar" slot="toolbar">
                <!-- Add a bold button -->
                <button class="ql-bold">
                    Bold
                </button>
                <button class="ql-italic">
                    Italic
                </button>

                <!-- Add font size dropdown -->
                <select class="ql-size">
                    <option value="small" />
                    <!-- Note a missing, thus falsy value, is used to reset to default -->
                    <option selected />
                    <option value="large" />
                    <option value="huge" />
                </select>

                <select class="ql-font">
                    <option selected="selected" />
                    <option value="serif" />
                    <option value="monospace" />
                </select>

                <!-- Add subscript and superscript buttons -->
                <button class="ql-script" value="sub" />
                <button class="ql-script" value="super" />
            </div>
        </quill-editor>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button  flat class="mr-3 mb-2 mt-3" @click="save">Submit</vs-button>
                <vs-button  to="/stories" color='secondary'  flat class="mr-3 mb-2 mt-3" @click="save">Submit</vs-button>
            </div>
        </div>
    </div>
</template>

<script>
    // eslint-disable-next-line
    import 'quill/dist/quill.core.css'
    // eslint-disable-next-line
    import 'quill/dist/quill.snow.css'
    // eslint-disable-next-line
    import 'quill/dist/quill.bubble.css'
    import {
        quillEditor
    } from 'vue-quill-editor'

    export default {
        components: {
            quillEditor,
        },
        data: () => ({
            editorOption: {
                modules: {
                    toolbar: '#toolbar',
                },
            },
            content: ``,
            file: ''
        }),
        methods: {
            save() {
                this.$vs.loading();
                const data = new FormData();
                data.append('media', this.file);
                data.append('body', this.content);
                this.axios.post(`${this.$apiUrl}/stories`, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    this.$vs.loading.close();
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Story Addedd',
                            text: ''
                        })
                    }
                }).catch(err =>{
                    this.$vs.loading.close();
                 this.$vs.notify({
                            color: 'danger',
                            title: 'Error When Add',
                            text: ''
                        })
              });
            },
            handleFile() {
                this.file = this.$refs.file.files[0];
            }
        },
    }
</script>